export default (state = {}) => {
  return {
    ...state,
    allProfiles: {},
    allOrders: {},
    allOrdersMeta: {},
    allOrdersState: {},
    allOrderDetail: {},
    allOrderDetailState: {},
    peopleToContact: {},
    coachAlias: {},
  };
};
